<template>
  <div
    v-horizontal-scroll
    class="flex overflow-x-auto py-2 will-change-scroll"
  >
    <selected-contacts-item
      v-for="contact in contacts"
      :key="contact.id"
      :contact="contact"
      :role="role!"
      :is-moderated="isModerated!"
      class="mr-4 shrink-0"
      @remove="onRemove"
      @toggle-role="toggleRole"
    />
  </div>
</template>

<script lang="ts" setup>
import { ConferenceMemberRole } from '@wui/im'


import { vHorizontalScroll } from '@/shared/directives/v-horizontal-scroll'
import { Contact, ExternalContact } from '@/shared/types/api'

import SelectedContactsItem from './selected-contacts-item.vue'


defineProps<{
  contacts:(Contact | ExternalContact)[],
  role?: ConferenceMemberRole
  isModerated?: boolean
}>()

const emit = defineEmits<{
  (event: 'remove', id: string): void;
  (event: 'toggle-role', id: string): void;
}>()

const onRemove = (id: string): void => {
  emit('remove', id)
}

const toggleRole = (internalNumber: string): void => {
  emit('toggle-role', internalNumber)
}
</script>
